import { render } from "./About.vue?vue&type=template&id=47100302"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=47100302&lang=css"
script.render = render

export default script